// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserSessionPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyByjXwZswb29PJOlGZ2pHToxoeQ6Qjw5Ss",
  authDomain: "vrn-task.firebaseapp.com",
  databaseURL: "https://vrn-task-default-rtdb.firebaseio.com",
  projectId: "vrn-task",
  storageBucket: "vrn-task.firebasestorage.app",
  messagingSenderId: "432527858568",
  appId: "1:432527858568:web:8472df04691c6869cbb83d",
  measurementId: "G-LBSNJXYLN9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Auth & Firestore services
export const auth = getAuth(app);
export const db = getFirestore(app);

// 🔐 Step A: Use SESSION persistence (logout when window closes)
setPersistence(auth, browserSessionPersistence)
  .then(() => {
    console.log("Firebase Auth set to session persistence (auto-logout on window close)");
  })
  .catch((err) => {
    console.error("Error setting auth persistence:", err);
  });

export default app;
